/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Layout, SidebarNav ve üst şerit sayfa başlığı bu route sözleşmesine bağlıdır.
 * Ürün özel sayfalar kendi router tanımlarını ekler; ana kabuk route sabitleri ortak kalır.
 */

/**
 * Router basename: Vite define’daki VITE_BASE_PATH (çoğu prod’da APPLICATION_CODE’dan).
 * Env’de BASE_PATH yoksa üretimde `vite.config` zaten `/${APPLICATION_CODE küçük harf}` verir.
 */
const detectBasePath = (): string => {
  const envBase = (import.meta.env.VITE_BASE_PATH || '').replace(/\/+$/, '');
  if (envBase) return envBase;

  if (typeof window !== 'undefined') {
    const match = window.location.pathname.match(/^\/([^/]+)/);
    if (match && (match[1] === 'core' || match[1] === 'agent')) {
      return `/${match[1]}`;
    }
  }

  return '';
};

export const BASE_PATH = detectBasePath();

/** Route configuration — segment genelde APPLICATION_CODE ile uyumludur */
export const ROUTES = {
  BASE: '/',
  LOGIN: '/login',
  APPS_MENU: '/',
  DASHBOARD: '/dashboard',
  COMPANIES: '/companies',
  ORGANIZATIONS: '/organizations',
  GROUPS: '/groups',
  EMAIL_ACCOUNTS: '/emails',
  USERS: '/users',
  ROLES: '/roles',
  SETTINGS: '/settings',
  SETTINGS_COMPANY: '/settings/company',
  SETTINGS_USER: '/settings/user',
  SETTINGS_SECURITY: '/settings/security',
  TRANSLATIONS: '/translations',
  CUSTOM_FIELDS: '/custom-fields',
  AI_PROVIDERS: '/ai-providers',
  /** Üst şerit genel arama */
  SEARCH: '/search',
  /** Üst şerit bildirim merkezi */
  NOTIFICATIONS: '/notifications',
  /** Aktivite günlükleri (Audit Trail) */
  ACTIVITY_LOGS: '/activity-logs',
} as const;

/** Tam path (base path + route); window.location.href için kullanın (örn. /core/login) */
export function getFullPath(route: string): string {
  return (BASE_PATH ? BASE_PATH + route : route);
}
